export const createEmulator = async function(devices) {
  const body = JSON.stringify(devices)

  return this.POST("/emulator", body, {}, {}, process.env.VUE_APP_EMULATORS_HOST)
}

export const getAllEmulators = async function () {
  return this.GET('/emulator', {}, {}, process.env.VUE_APP_EMULATORS_HOST)
}
